import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  rewardsCategories1: [],
  exportData: [],
  transactionTypeBase: {
    totalCount: 0,
    entities: [],
    paymentCount: 0,
    ctCount: 0,
    coinCount: 0,
    couponCount: 0,
    drCount: 0,
  },
  rewardTransactions: {
    totalCount: 0,
    entities: [],
    suceessCount: 0,
    rejectedCount: 0,
    pendingCount: 0,
  },
  rewardClaimed: {
    dPendingCount: 0,
    totalCount: 0,
    entities: [],
  },
  currency: [],
  levelForEdit: {},
  lastError: null,
  usersCount: 0,
  gameList: [],
  contestsList: [],
};
export const callTypes = {
  list: "list",
  action: "action",
};
export const VINewContestsReportSlice = createSlice({
  name: "VINewContestsReportList",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
        state.actionsLoading = false;
        state.totalCount = 0;
      } else {
        state.listLoading = false;
        state.actionsLoading = false;
        state.totalCount = 0;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // singleItemFetched
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.levelForEdit = action.payload.levelForEdit;
      state.error = null;
    },
    // listFetched
    listFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("entities listFetched", entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    Summery: (state, action) => {
      console.log(action);
      const { usersCount } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.usersCount = usersCount;
    },
    SubscriptionListFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("entities SubscriptionListFetched", entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    listScrimFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("entities listScrimFetched", entities);
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    // CompanyList
    CompanyList: (state, action) => {
      const { companyList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyList = companyList;
    },
    // CompanyList
    CompanyListstatus: (state, action) => {
      const { companyListstatus } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyListstatus = companyListstatus;
    },
    // PartnerList
    PartnerList: (state, action) => {
      const { partnerList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.partnerList = partnerList;
    },
    contestsExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    contestlistExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    rewardslistExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    scrimslistExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    subscriptionlistExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    coinslistExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    // listFetched
    typeBaseListFetched: (state, action) => {
      const {
        totalCount,
        entities,
        paymentCount,
        ctCount,
        coinCount,
        couponCount,
        drCount,
      } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.transactionTypeBase.entities = entities;
      state.transactionTypeBase.totalCount = totalCount;
      state.transactionTypeBase.paymentCount = paymentCount;
      state.transactionTypeBase.ctCount = ctCount;
      state.transactionTypeBase.coinCount = coinCount;
      state.transactionTypeBase.couponCount = couponCount;
      state.transactionTypeBase.drCount = drCount;
    },
    rewardsCategoriesSearch1: (state, action) => {
      const { rewardsCategories1 } = action.payload;

      // Log the rewardsCategories1 data
      console.log(rewardsCategories1, "kfdngbfhgbfgjf");

      // Manipulate the data if needed
      // For example, you can filter out certain elements or modify properties here

      // Update the Redux state
      state.error = null;
      state.errorFound = false;
      state.rewardsCategories1 = rewardsCategories1;
    },
    // listFetched
    listRewardTransactionsFetched: (state, action) => {
      const {
        totalCount,
        entities,
        pendingCount,
        successCount,
        rejectedCount,
      } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.rewardTransactions.entities = entities;
      state.rewardTransactions.totalCount = totalCount;
      state.rewardTransactions.pendingCount = pendingCount;
      state.rewardTransactions.successCount = successCount;
      state.rewardTransactions.rejectedCount = rejectedCount;
    },
    // listFetched
    listRewardClaimedFetched: (state, action) => {
      const { totalCount, entities, dPendingCount } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.rewardClaimed.entities = entities;
      state.rewardClaimed.totalCount = totalCount;
      state.rewardClaimed.dPendingCount = dPendingCount;
    },
    // itemCreated
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.item);
      state.entities = [];
    },
    currency: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.currency = entities;
      // state.totalCount = totalCount;
    },
    // itemUpdated
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
    },
    // itemDeleted
    itemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },
    // itemsDeleted
    itemsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => !action.payload.ids.includes(el.id)
      );
    },
    // itemStatusUpdated
    itemStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },
    contestsList: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestsList = entities;
    }
  },
});
